<template>
    <li
        class="house-grid-item broker"
        :class="{ 'house-sold': soldDate }"
        :title="address"
        @mouseenter="onMouseEnter"
        @mouseleave="onMouseLeave"
        @click="openDetail(link, $event)"
    >
        <article>
            <a
                :href="linkData.href"
                :target="linkData.target"
                :aria-label="linkData['aria-label']"
                :rel="linkData.rel"
                :self="linkData.self"
            >
                <img-swiper
                    class="house-preview"
                    :imgNotZoom="imgNotZoom"
                    @change="onPreviewChange"
                    :allImagesJson="previewsJson"
                    :alt="address"
                    dir="width"
                    :errorImg="defHouseImg"
                    :showSwitch="showSwitch && !isShowMask"
                >
                    <div class="mask"></div>
                    <div class="house-basic clearfix">
                        <span
                            class="vertical-line"
                            v-for="item in basic"
                            :key="item.key"
                        >{{ item.text }}</span>
                    </div>
                    <label v-if="showCheckbox" class="checkbox" @click.stop>
                        <input
                            type="checkbox"
                            v-model="checkValue"
                            @change="onChecked"
                        />
                        <span class="iconfont icon-checked-light"></span>
                    </label>
                    <span v-if="tour3D" class="house-count">
                        <i class="iconfont icon-3d"></i>{{ $t('md-house.3d') }}</span>
                    <template v-else>
                        <span
                            v-if="picturesNum > 1"
                            class="house-count"
                            :class="{
                                hide: !isMobile || previews.length <= 1,
                                'hover-show': previews.length > 1
                            }"
                        >{{ previewIndex }}/{{ picturesNum }}</span>
                        <span
                            v-if="picturesNum > 1"
                            class="house-count"
                            :class="{
                                hide: isMobile && previews.length > 1,
                                'hover-hide': previews.length > 1
                            }"
                        >
                            <i class="iconfont icon-pic"></i>
                            {{ picturesNum }}
                        </span>
                    </template>
                    <span
                        class="collect top"
                        :class="{ active: heartActive || collected }"
                        v-if="!soldDate && !forCMS && !widget"
                        @click.stop.prevent="collect"
                        @mouseenter.stop="heartActive = true"
                        @mouseleave.stop="heartActive = false"
                    ><i class="iconfont icon-heart-fill"></i></span>
                    <template #mask>
                        <house-mask v-if="isShowMask" />
                    </template>
                </img-swiper>
            </a>
            <!-- status -->
            <div
                v-if="exclusiveTag || tag || soldDate"
                class="house-status-container"
            >
                <only-client v-if="soldDate">
                    <house-tag class="sold" theme="v5" :value="getHouseTagValue()" />
                </only-client>
                <template v-else>
                    <house-tag
                        v-bind="exclusiveTag"
                        v-if="exclusiveTag"
                        theme="v5"
                    />
                    <house-tag v-bind="tag" v-if="tag" theme="v5" />
                </template>
            </div>

            <div class="desc">
                <span
                    class="collect bot"
                    :class="{ active: heartActive || collected }"
                    v-if="!soldDate && !forCMS && !widget"
                    @click.stop.prevent="collect"
                    @mouseenter.stop="heartActive = true"
                    @mouseleave.stop="heartActive = false"
                ><i class="iconfont icon-heart-fill"></i></span>
                <!-- price -->
                <div class="house-price-wrap">
                    <title-mask v-if="isShowMask" />
                    <template v-else-if="soldDate">
                        <no-disclosure
                            class="sold"
                            v-if="!!house.nodisclosureDes || hidePrice"
                            :des="
                                hidePrice
                                    ? $t('md-house.nondisclosure')
                                    : house.nodisclosureDes
                            "
                        />
                        <template v-else>
                            <span class="house-sold-price">
                                {{
                                    $ft.trim(showSoldPrice ? soldPrice : price)
                                }}
                            </span>
                            <span
                                class="house-initial-price"
                                v-if="showAllPrice && initialPrice"
                            >
                                {{ $ft.trim(initialPrice) }}
                            </span>
                        </template>
                        <span
                            :class="[
                                'house-trend',
                                trendUp ? 'trend-up' : 'trend-down'
                            ]"
                            v-if="soldDate && showAllPrice && trend"
                        >
                            {{ trend }}
                        </span>
                    </template>
                    <template v-else>
                        <p
                            class="house-price"
                            v-if="house.nodisclosureDes == null"
                        >
                            {{ $ft.trim(price) }}
                        </p>
                        <no-disclosure
                            class="unsold"
                            v-else
                            :des="house.nodisclosureDes"
                        />
                    </template>
                </div>

                <div :class="['house-footer', soldDate ? 'sold-footer' : '']">
                    <h3 class="house-address">
                        <a
                            :href="linkData.href"
                            :target="linkData.target"
                            :aria-label="linkData['aria-label']"
                            :rel="linkData.rel"
                            :self="linkData.self"
                        >{{ address }}</a>
                    </h3>
                    <div class="house-info">
                        <div class="house-info-detail">
                            <!-- <p class="house-tag">{{ propertyType }}</p> -->
                            <!-- mls number  Do not do internationalization  -->
                            <p v-if="showMls" class="house-mls-id">
                                MLS# {{ mlsid }}
                            </p>
                            <p v-if="!isShowMask" class="house-provided ws-pre-wrap">{{ provided }}</p>
                        </div>
                        <site-img
                            v-if="mlsLogo"
                            class="house-mls-logo"
                            backSize="contain"
                            :src="mlsLogo"
                            :alt="mlsAlt"
                            :size="40"
                            dir="height"
                        />
                    </div>
                </div>
            </div>
        </article>
        <schema-info :info="seoSchema" v-if="seoSchema" />
    </li>
</template>

<script>
import Item from '../item';
import ItemForSearch from '../itemForSearch';
export default {
    mixins: [Item, ItemForSearch],
    data: function() {
        return {
            heartActive: false
        };
    }
};
</script>
<style lang="scss">
@import '../../../theme/mixin.scss';
@import '../../../theme/media.scss';
.house-grid-item.broker {
    --mask-bg-color: rgba(255, 255, 255, 0.65);
    --mask-text-color: #202437;
    position: relative;
    border-radius: 5px;
    border: 1px solid #dadada;
    > article {
        width: 100%;
        height: 100%;
    }
    &:hover {
        box-shadow: 0 8px 20px 0 rgba(0, 10, 30, 0.1);
        border: 1px solid var(--color-theme);
    }
    .house-preview {
        position: relative;
        width: 100%;
        padding-top: 210px;
        overflow: hidden;
        .mask {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 40px;
            z-index: 1;
            pointer-events: none;
            background-image: linear-gradient(
                to bottom,
                rgba(255, 255, 255, 0),
                rgba(0, 0, 0, 0.7) 100%
            );
        }
        .slot-wraper > .house-count {
            position: absolute;
            top: 0;
            right: 0;
            z-index: 1;
            color: white;
            // width: 51px;
            height: 29px;
            line-height: 27px;
            font-size: 14px;
            display: flex;
            justify-content: center;
            background-color: rgba(0, 0, 0, 0.4);
            border-bottom-left-radius: 6px;
            border-top-right-radius: 5px;
            padding: 0 2px;
            .iconfont {
                margin-right: 5px;

                position: relative;
                top: 1px;
            }
        }
        & {
            .house-count.hide {
                display: none;
            }
            &:hover .house-count {
                text-align: center;
                &.hover-show {
                    display: block;
                }
                &.hover-hide {
                    display: none;
                }
            }
        }
        .icon-fav {
            z-index: 1;
            box-shadow: 2px 2px 10px 0 rgba(0, 10, 30, 0.1);
        }
        .checkbox {
            position: absolute;
            top: 10px;
            left: 10px;
            z-index: 1;
            text-align: center;
            box-shadow: var(--box-shadow);
            border: solid 1px #ebecf1;
            line-height: 15px;
            width: 15px;
            height: 15px;
            vertical-align: middle;
            font-size: 14px;
            @include color-theme();
            background-color: white;
            cursor: pointer;
            input {
                display: none;
                & + .iconfont {
                    display: none;
                }
            }
            input:checked + .iconfont {
                display: block;
                font-size: 14px;
            }
        }
    }
    .collect {
        position: absolute;
        right: 15px;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        box-shadow: 0 9px 10px 0 rgba(60, 60, 76, 0.05),
            0 5px 10px 0 rgba(60, 60, 76, 0.03);
        background-color: #d8d8db;
        text-align: center;
        line-height: 30px;
        z-index: 1;
        cursor: pointer;

        &.top {
            bottom: 0;
            transform: translateY(50%);
        }
        &.bot {
            top: 0;
            transform: translateY(-50%);
        }
        i {
            color: #fff;
            font-size: 13px;
        }
        &.active {
            background: #fff;
            i {
                color: #f0454c;
            }
        }
        .icon-heart,
        .icon-heart-fill {
            cursor: pointer;
        }
    }
    .desc {
        border-top: none;
        padding: 15px;
        position: relative;
        z-index: 2;
    }
    .house-status-container {
        position: absolute;
        left: 15px;
        top: 15px;
        z-index: 2;
        .house-status {
            display: block;
            width: fit-content;
            &:first-child {
                margin-bottom: 8px;
            }
        }
    }

    .house-price-wrap {
        font-family: var(--font-bold);
        font-size: 24px;
        color: #191919;
        margin-top: 2px;
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        flex-wrap: wrap;
        .sold {
            margin-right: 5px;
        }
    }
    .house-price,
    .house-sold-price,
    .hide-price {
        font-family: var(--font-bold);
        font-size: 24px;
        color: #191919;
        position: relative;
        cursor: pointer;
        .link {
            text-decoration: underline;
            color: var(--color-theme);
            cursor: pointer;
        }

        &.hide-price {
            font-size: 16px;
            color: #000;
        }
    }
    .house-initial-price {
        text-decoration: line-through;
        font: 16px var(--font-normal);
        color: #191919;
        line-height: 22px;
        margin-left: 5px;
    }
    .house-sold-date {
        margin-top: 10px;
        margin-bottom: 10px;
        line-height: 1.43;
        color: #c7c8d1;
    }

    .house-trend {
        font-size: 12px;
        float: right;
        font-family: var(--font-normal);
        &:before {
            margin-top: 3px;
            margin-right: 4px;
            margin-left: 3px;
            vertical-align: top;
            content: '';
            display: inline-block;
            width: 0;
            height: 0;
            border-left: solid 5px transparent;
            border-right: solid 5px transparent;
            border-bottom: solid 6px #29cb97;
        }
        &.trend-up {
            color: #29cb97;
        }
        &.trend-down {
            color: #ff5661;
            &:before {
                border-top: solid 6px #ff5661;
                border-bottom: none;
            }
        }
    }

    .house-basic {
        position: absolute;
        bottom: 15px;
        left: 15px;
        z-index: 2;
        > span {
            float: left;
            font: 12px var(--font-normal);
            color: #fff;
        }
        .vertical-line {
            white-space: nowrap;
        }
        .vertical-line:after {
            content: '|';
            display: inline;
            margin: 0 12px;
        }
        .vertical-line:nth-last-child(1):after {
            content: '';
        }
    }
    .house-footer {
        height: auto;
        min-height: 94px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .house-address {
            @include webkitBox(2);
            font-size: 14px;
            font-weight: 400;
            color: #505050;
            line-height: 1.25;
            margin: 0 0 17px 0;
        }
        .house-info {
            display: flex;
            flex-wrap: nowrap;
            align-items: flex-end;
            justify-content: flex-end;
            .house-info-detail {
                height: auto;
                overflow: hidden;
                flex-grow: 1;
            }
            .house-mls-logo {
                max-width: 100px;
                max-height: 36px;
                margin-left: 26px;
                margin-bottom: 0px;
                flex-grow: 0;
                flex-shrink: 0;
                object-fit: contain;
            }
        }
        .house-tag,
        .house-provided,
        .house-mls-id {
            color: #505050;
            font: 12px var(--font-normal);
            font-style: italic;
            line-height: 1.43;
        }
        &.sold-footer {
            height: auto;
            min-height: 84px;
            .house-address {
                font-size: 14px;
                line-height: 1.43;
                margin-bottom: 10px;
            }
            .house-tag,
            .house-mls-id {
                font-size: 12px;
            }
            .house-provided {
                font-size: 14px;
            }
        }
    }
    &:hover {
        .house-address {
            text-decoration: underline;
        }
    }
    .nodisclosure {
        &.unsold {
            margin-top: 4px;
        }
        &.sold {
            margin-bottom: 18px;
            .dollar {
                line-height: 29px;
            }
        }
        @include media-600 {
            .dollar {
                font-size: 20px;
            }
            .secret {
                font-size: 12px;
            }
            .des {
                font-size: 12px;
            }
        }
    }
}
</style>
